import { useEffect, useState } from 'react';
import {
  displayErrorNotification,
  displaySuccessNotification
} from '../../../../../../utils/displayNudosStandardNotifications';
import NudosConfirmActionModal from '../../../../../../components/NudosComponents/NudosConfirmActionModal/NudosConfirmActionModal';
import { NudosSelectButton } from '../../../../../../components/NudosComponents';
import { updateSubscription } from '../../../../../../services/bussines';
import { CLIENT_PLAN_TYPES, TClient } from '../../../../../../types/client.types';
import useOrganizationState from 'state/useOrganizationState';

const PlanType = ({
  organizationId,
  updateWithoutLoaders
}: {
  organizationId: string;
  updateWithoutLoaders?: () => Promise<void>;
}) => {
  const { organizationData, generalLoader } = useOrganizationState();

  const [showModal, setShowModal] = useState<boolean>(false);
  const [planType, setPlanType] = useState<TClient>(CLIENT_PLAN_TYPES.STANDARD);
  const [clientPlan, setClientPlan] = useState<TClient>(CLIENT_PLAN_TYPES.STANDARD);
  const [modalButtonIsLoading, setModalButtonIsLoading] = useState<boolean>(false);
  const availablePlans = [CLIENT_PLAN_TYPES.STANDARD, CLIENT_PLAN_TYPES.PLATINUM];

  const loadingPlanType = generalLoader;

  const handleShowModal = (type: TClient) => {
    setShowModal(!showModal);
    setClientPlan(type);
  };
  const closeModal = () => {
    setShowModal(false);
  };

  const assignPlanType = () => {
    if (!organizationData) return;
    const { subscriptionsDetails } = organizationData;
    const { levelSubscription } = subscriptionsDetails;
    const renderedLevelSubscription = {
      [CLIENT_PLAN_TYPES.FREE]: CLIENT_PLAN_TYPES.STANDARD,
      [CLIENT_PLAN_TYPES.LITE]: CLIENT_PLAN_TYPES.PLATINUM,
      [CLIENT_PLAN_TYPES.VIP]: CLIENT_PLAN_TYPES.VIP,
      [CLIENT_PLAN_TYPES.DEEL]: CLIENT_PLAN_TYPES.DEEL
    };
    setPlanType(renderedLevelSubscription[levelSubscription] as TClient);
  };

  const handleUpdatePlanType = async () => {
    try {
      setModalButtonIsLoading(true);
      const subscriptionId = clientPlan === CLIENT_PLAN_TYPES.STANDARD ? 1 : 2;
      await updateSubscription(+organizationId, { platformSubscriptionId: subscriptionId });
      setPlanType(clientPlan);
      await updateWithoutLoaders?.();
      displaySuccessNotification({ customJSXMessage: <>Se actualizó la información correctamente</> });
    } catch (error) {
      displayErrorNotification();
    } finally {
      setModalButtonIsLoading(false);
      closeModal();
    }
  };

  const modalContinueButtonText = () => {
    if (clientPlan === CLIENT_PLAN_TYPES.PLATINUM) {
      return 'Marcar como Platinum';
    }
    return 'Marcar como Standard';
  };

  const modalText = () => {
    if (clientPlan === CLIENT_PLAN_TYPES.PLATINUM) {
      return 'Al marcar como Platinum, se aplicarán descuentos en compras y servicios logísticos a este cliente, ¿estás seguro?';
    }
    return 'Al marcar como Standard, el cliente perderá descuentos en compras y servicios logísticos ¿estás seguro?';
  };

  useEffect(() => {
    assignPlanType();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!availablePlans.includes(planType as CLIENT_PLAN_TYPES)) return <></>;

  return (
    <>
      {showModal && (
        <NudosConfirmActionModal
          firstButtonAction={closeModal}
          secondButtonAction={handleUpdatePlanType}
          firstButtonText="Cancelar"
          secondButtonText={modalContinueButtonText()}
          modalText={modalText()}
          isLoading={modalButtonIsLoading}
        />
      )}
      <div className="accountTitle">Tipo de plan</div>
      <div className="accountOptions">
        {loadingPlanType ? (
          <div className="loaderOptions animationLoader" />
        ) : (
          <>
            <div className="optionAccount">
              <NudosSelectButton
                colorPalette="black"
                handleClickButton={() => handleShowModal(CLIENT_PLAN_TYPES.STANDARD)}
                isButtonActive={planType === CLIENT_PLAN_TYPES.STANDARD}
              />
              <div className="optionText">Standard</div>
            </div>
            <div className="optionAccount">
              <NudosSelectButton
                colorPalette="black"
                handleClickButton={() => handleShowModal(CLIENT_PLAN_TYPES.PLATINUM)}
                isButtonActive={planType === CLIENT_PLAN_TYPES.PLATINUM}
              />
              <div className="optionText">Platinum</div>
            </div>
          </>
        )}
      </div>
      <div className="divider" />
    </>
  );
};

export default PlanType;
